module.exports = __webpack_public_path__ + "static/media/27OCHA12.4f0adbd7.jpg";